import ApiCore from './api-core'
import { PUBLIC } from './constants'
export default class Geo extends ApiCore {
  constructor(store) {
    super(store, `${PUBLIC}/geo`)
  }

  trafficPlanList(filter) {
    return this._request({
      action: 'trafficPlan/list',
      method: 'GET',
      params: filter
    })
  }

  extractCity(filter) {
    return this._request({
      action: 'city/extract',
      method: 'GET',
      params: filter
    })
  }

  extractTrafficPlan(filter) {
    return this._request({
      action: 'trafficPlan/extract',
      method: 'GET',
      params: filter
    })
  }
}
